import { baseUniDriverFactory } from '../utils/test-utils/unidriver';

export const toggleDriverFactory = base => {
  const { element, exists } = baseUniDriverFactory(base);
  return {
    exists,
    element,
  };
};
